module.exports = __webpack_public_path__ + "static/media/logo.78abe30c.png";